export const DataTypes = {
  M4Str: 0,
  M4Date: 1,
  M4Val: 2,
};

export function FixRecordMissingFields(record, f1, f2, f3) {
  let nrec = record;
  if (f1) {
    for (let i in f1) {
      if (f1[i].hasOwnProperty('group')) {
        for (let j in f1[i]['group']) {
          if (j == 'fields') {
            for (let s in f1[i]['group']['fields']) {
              if (
                nrec.hasOwnProperty(f1[i]['group']['fields'][s].dataKey) ==
                false
              ) {
                nrec[f1[i]['group']['fields'][s].dataKey] = '';
              }
            }
          }
        }
      }
    }
  }
  if (f2) {
    for (let i in f2) {
      if (f2[i].hasOwnProperty('group')) {
        for (let j in f2[i]['group']) {
          if (j == 'fields') {
            for (let s in f2[i]['group']['fields']) {
              if (
                nrec.hasOwnProperty(f2[i]['group']['fields'][s].dataKey) ==
                false
              ) {
                nrec[f2[i]['group']['fields'][s].dataKey] = '';
              }
            }
          }
        }
      }
    }
  }
  if (f3) {
    if (nrec.hasOwnProperty('rows') == false) {
      nrec.rows = [];
    }
    for (let i in f3) {
      for (let rindex in nrec.rows) {
        if (nrec.rows[rindex].hasOwnProperty(f3[i].dataKey) == false) {
          nrec.rows[rindex][f3[i].dataKey] = '';
        }
      }
    }
  }

  return nrec;
}
